import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { TimeFormatService } from '../services/time-format.service';

function filterFunction(timeFormatService: TimeFormatService, $filter: ng.IFilterService, $localStorage: ngStorage.StorageService) {
    return function formatTime(
        time: string,
        ...formatParam: string[]
    ): string {
        const defaultTimeFormat = ['shortDateOnly', 'shortTimeOnly'];
        const lang = $localStorage.sellerAuthorizationData ? $localStorage.sellerAuthorizationData.languageIso : null;
        const timeFormatSettings = timeFormatService.getTimeFormatSettings(lang);

        function getTimePattern(paramsArr: string[]) {
            return paramsArr.map((param) => timeFormatSettings[param]).join(', ');
        }

        const incomeParams = formatParam.length !== 0 ?
            getTimePattern(formatParam) : getTimePattern(defaultTimeFormat);
        return time ? $filter('date')(time, incomeParams).replace('am', 'AM').replace('pm', 'PM') : '';
    };
}

angular.module('app.common').filter('formatTime', filterFunction);

filterFunction.$inject = ['timeFormatService', '$filter', '$localStorage'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/format-time.filter.ts